export default __webpack_public_path__ + "static/media/navbar-icon-upcoming-promotions.450d1a6d.svg";